import { lazySaveToCloud } from 'owa-attachment-savetocloud-deeplink';
import { lazyInitializeNotifications } from 'owa-mail-post-boot/lib/deeplinkIndex';

export interface SaveToCloudRouteParamaters {
    itemId: string;
    attachmentId: string;
    subscriptionId: string;
}

async function deepLinkSaveToCloudRouteHandler(parameters: SaveToCloudRouteParamaters) {
    if (parameters.attachmentId) {
        const initializeNotifications = await lazyInitializeNotifications.import();
        await initializeNotifications();
        const saveToCloud = await lazySaveToCloud.import();
        saveToCloud(parameters.attachmentId, parameters.subscriptionId);
    }
}

export { deepLinkSaveToCloudRouteHandler };
